import React from 'react'
import {obvioRoutes} from 'obvio/Routes'
import {useBreadcrumbs} from 'lib/ui/BreadcrumbProvider'
import Layout from 'obvio/user/Layout'
import Form from 'obvio/AccountSettingsPage/Form'
import Page from 'lib/ui/layout/Page'

export default function AccountSettingsPage() {
  useBreadcrumbs([
    {
      title: 'Account Settings',
      url: obvioRoutes.account,
    },
  ])

  return (
    <Layout>
      <Page>
        <Form />
      </Page>
    </Layout>
  )
}
